import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const textareaInputFn = /* @__PURE__ */ createRecipe('textarea-input', {
  "size": "l",
  "color": "neutral",
  "border": 50
}, [])

const textareaInputVariantMap = {
  "size": [
    "l",
    "m"
  ],
  "border": [
    "50",
    "100"
  ],
  "color": [
    "danger",
    "neutral",
    "primary"
  ]
}

const textareaInputVariantKeys = Object.keys(textareaInputVariantMap)

export const textareaInput = /* @__PURE__ */ Object.assign(memo(textareaInputFn.recipeFn), {
  __recipe__: true,
  __name__: 'textareaInput',
  __getCompoundVariantCss__: textareaInputFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: textareaInputVariantKeys,
  variantMap: textareaInputVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, textareaInputVariantKeys)
  },
  getVariantProps: textareaInputFn.getVariantProps,
})